// This should only be for simple variables that are used in more than one place.
// DO NOT PLACE ANY FUNCTIONS HERE!!

export let modalCloseTimeOut = 1500; // Example: How long to show a success message before closing the modal
